/**
 * After DOM is ready, replace all [var:shortCode] in text content with values from
 * window.__CMS_VARIABLES__ (injected by the server). Covers titles, plain text, rich text, etc.
 */
const SHORTCODE_REGEX = /\[var:([a-zA-Z0-9_]+)\]/g;

function replaceInTextNode(node, map) {
  const text = node.textContent;
  if (!text || !text.includes('[var:')) return;
  const replaced = text.replace(SHORTCODE_REGEX, (match, shortCode) => map[shortCode] ?? match);
  if (replaced !== text) node.textContent = replaced;
}

function replaceCmsVariables() {
  const map = window.__CMS_VARIABLES__;
  if (!map || typeof map !== 'object') return;

  const walker = document.createTreeWalker(
    document.body,
    NodeFilter.SHOW_TEXT,
    {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent) return NodeFilter.FILTER_REJECT;
        const tagName = parent.tagName?.toLowerCase();
        if (tagName === 'script' || tagName === 'style' || tagName === 'noscript') {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      },
    }
  );

  const nodes = [];
  let n;
  while ((n = walker.nextNode())) nodes.push(n);
  nodes.forEach((node) => replaceInTextNode(node, map));
}

export default replaceCmsVariables;
